export const privacyPolicySections = [
  {
    id: "intro_001",
    title: "1. Introduction",
    details: [
      {
        description:
          "Nivaran Foundation ('we,' 'us,' or 'our') is a Nepal-focused foundation registered in the United States and operating worldwide. We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website https://www.nivaranfoundation.org (the 'Site'), interact with us through other online platforms, or engage with us offline.",
      },
      {
        description:
          "This Privacy Policy applies to all information collected through our Site, mobile applications, email communications, social media channels, events, fundraising activities, and any other interactions you have with us. We comply with applicable data privacy laws, including but not limited to the California Consumer Privacy Act (CCPA), the General Data Protection Regulation (GDPR), and other relevant international and US privacy laws.",
      },
    ],
  },
  {
    id: "info_collect_002",
    title: "2. Information We Collect",
    details: [
      {
        description:
          "We collect both Personal Information and Non-Personal Information to provide and improve our services.",
      },
      {
        description:
          "2.1. Personal Information: This is information that can be used to identify you as an individual. We may collect:",
        list: [
          "Identity Data: Name, username, or similar identifier.",
          "Contact Data: Billing address, delivery address, email address, and telephone numbers.",
          "Financial Data: Bank account and payment card details (donations are processed by GoDaddy Payments and other third-party payment processors; we do not store full card numbers on our servers).",
          "Monthly giving: With your authorization, we store an encrypted payment token and your donor and billing information to process monthly gifts. We do not store your full card number or security code. Cancelling stops future charges and removes the token from our active subscription record.",
          "Address suggestions: When address search is available, the address text you type and your selected country are sent to Photon, an address search service operated by Komoot using OpenStreetMap data, to suggest and complete your billing address. You can enter your address manually instead.",
          "Transaction Data: Details about payments to and from you and other details of donations or services you have purchased from us.",
          "Technical Data: Internet Protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform.",
          "Country prefill: To suggest a country in the donation form, we use a country supplied by our hosting service or send your IP address to IPWhois (ipwho.is) for a country lookup. We do not send your name, email, billing address or payment details to this service. Device time zone and language are fallbacks, and you can change the suggested country.",
          "Profile Data: Your username and password, donations or orders made by you, your interests, preferences, feedback, and survey responses.",
          "Usage Data: Information about how you use our website, products, and services.",
          "Marketing and Communications Data: Your preferences in receiving marketing from us and your communication preferences.",
          "Volunteer/Employment Data: Resumes, cover letters, and background check information for applicants.",
        ],
      },
      {
        description:
          "2.2. Methods of Collection: We collect data through:",
        list: [
          "Direct Interactions: You may give us your Identity, Contact, and Financial Data by filling in forms or by corresponding with us by post, phone, email, or otherwise.",
          "Automated Technologies: As you interact with our website, we may automatically collect Technical Data about your equipment, browsing actions, and patterns using cookies and similar technologies.",
          "Advertising Measurement: When Google Ads measurement is active, Google tags and advertising cookies record whether a visit from a Google ad led to a completed donation, including the donation amount and a transaction reference but not your name, email address, billing address, or card details, and you can decline these cookies using our cookie banner.",
          "LinkedIn Advertising: When LinkedIn measurement is active, the LinkedIn Insight Tag and LinkedIn cookies record visits to our website and whether a visit from a LinkedIn ad led to a completed donation. LinkedIn may link this activity to your LinkedIn account and use it to show our ads to past visitors. It does not receive your name, email address, billing address, or card details, and you can decline these cookies using our cookie banner.",
          "Third Parties: We may receive personal data about you from various third parties, such as analytics providers (e.g., Google), advertising networks, and payment processors.",
        ],
      },
    ],
  },
  {
    id: "purpose_collect_003",
    title: "3. Purpose of Data Collection",
    details: [
      {
        description:
          "We collect and use your data for the following specific purposes:",
        list: [
          "Service Delivery: To provide you with the information, products, or services that you request from us.",
          "Donation Processing: To process your charitable donations and provide donation acknowledgments.",
          "Communication: To communicate with you about your account, transactions, and program updates.",
          "Fundraising and Marketing: To provide you with information about our mission, impact, and fundraising campaigns (where you have opted in).",
          "Volunteer/Staff Management: To process applications and manage our workforce.",
          "Analytics and Improvement: To use data analytics to improve our website, products/services, marketing, customer relationships, and experiences.",
          "Legal Compliance: To comply with a legal obligation or regulatory requirement.",
        ],
      },
    ],
  },
  {
    id: "data_usage_004",
    title: "4. Data Usage and Processing",
    details: [
      {
        description:
          "We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:",
        list: [
          "Consent: Where you have given us clear consent to process your personal data for a specific purpose.",
          "Contract: Where we need to perform the contract we are about to enter into or have entered into with you.",
          "Legal Obligation: Where we need to comply with a legal or regulatory obligation.",
          "Legitimate Interests: Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.",
        ],
      },
      {
        description:
          "We process your data on secure servers and limit access to employees, agents, contractors, and other third parties who have a business need to know.",
      },
    ],
  },
  {
    id: "data_sharing_005",
    title: "5. Data Sharing and Disclosure",
    details: [
      {
        description:
          "We do not sell your personal information. We may share your data with:",
        list: [
          "Service Providers: Third-party companies that perform services on our behalf, such as payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.",
          "Legal Authorities: If required to do so by law or in response to valid requests by public authorities (e.g., a court or a government agency).",
          "Business Transfers: In connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.",
          "Partners: With your consent, we may share information with partner organizations for joint initiatives.",
        ],
      },
    ],
  },
  {
    id: "security_006",
    title: "6. Data Security",
    details: [
      {
        description:
          "We have implemented appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed.",
        list: [
          "Encryption: Sensitive data (like payment information) is encrypted during transmission.",
          "Access Controls: Access to personal data is restricted to authorized personnel only.",
          "Regular Audits: We conduct regular security assessments of our systems.",
          "Data Breach Procedures: We have procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.",
        ],
      },
    ],
  },
  {
    id: "user_rights_007",
    title: "7. User Rights",
    details: [
      {
        description:
          "Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:",
        list: [
          "Request Access: Request a copy of the personal data we hold about you.",
          "Request Correction: Request correction of the personal data that we hold about you.",
          "Request Erasure: Request us to delete or remove personal data where there is no good reason for us continuing to process it.",
          "Object to Processing: Object to processing of your personal data where we are relying on a legitimate interest.",
          "Request Restriction: Request the restriction of processing of your personal data.",
          "Request Transfer: Request the transfer of your personal data to you or to a third party.",
          "Withdraw Consent: Withdraw consent at any time where we are relying on consent to process your personal data.",
        ],
      },
      {
        description:
          "To exercise any of these rights, please contact us at privacy@nivaranfoundation.org.",
      },
    ],
  },
  {
    id: "retention_008",
    title: "8. Data Retention",
    details: [
      {
        description:
          "We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.",
      },
      {
        description:
          "To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure, the purposes for which we process your personal data, and applicable legal requirements.",
      },
    ],
  },
  {
    id: "international_transfer_009",
    title: "9. International Data Transfers",
    details: [
      {
        description:
          "As an international organization, we may transfer, store, and process your information in countries other than your own, including the United States and Nepal. Whenever we transfer your personal data out of the EEA, we ensure a similar degree of protection is afforded to it by ensuring at least one of the following safeguards is implemented:",
        list: [
          "We will only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the European Commission.",
          "Where we use certain service providers, we may use specific contracts approved by the European Commission which give personal data the same protection it has in Europe.",
        ],
      },
    ],
  },
  {
    id: "children_010",
    title: "10. Children's Privacy",
    details: [
      {
        description:
          "Our Services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us. If we become aware that we have collected personal information from children without verification of parental consent, we take steps to remove that information from our servers.",
      },
    ],
  },
  {
    id: "contact_011",
    title: "11. Contact Information",
    details: [
      {
        description:
          "If you have any questions about this Privacy Policy or our privacy practices, please contact us at:",
      },
      {
        description: "NIVARAN FOUNDATION, INC.",
      },
      {
        description:
          "1025 Massachusetts Ave, Suite 303, Arlington, MA 02476, USA",
      },
      {
        description: "Email: privacy@nivaranfoundation.org",
      },
      {
        description: "Phone: (339) 707-2895",
      },
      {
        description: "EIN: 41-2656587",
      },
    ],
  },
];
